export default "__VITE_ASSET__6caa921d__"